/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { sharedListPagesFilterStyle } from "@monsma/App/WidgetExtensions/MyAccount/MyAccountListPagesExtension";
import { rfqMyQuotesFilterStyles } from "@monsma/Overrides/Widgets/RfqMyQuotes/RfqMyQuotesFilter";
import { css } from "styled-components";

rfqMyQuotesFilterStyles.container = sharedListPagesFilterStyle.container;

rfqMyQuotesFilterStyles.headingItem = {
    css: css`
        display: none;
    `,
};

rfqMyQuotesFilterStyles.fromGridItem = sharedListPagesFilterStyle.dateGridItem;

rfqMyQuotesFilterStyles.toGridItem = sharedListPagesFilterStyle.dateGridItem;

rfqMyQuotesFilterStyles.expireFromGridItem = sharedListPagesFilterStyle.dateGridItem;

rfqMyQuotesFilterStyles.expireToGridItem = sharedListPagesFilterStyle.dateGridItem;

rfqMyQuotesFilterStyles.customerGridItem = sharedListPagesFilterStyle.normalGridItem;

rfqMyQuotesFilterStyles.quoteNumberGridItem = sharedListPagesFilterStyle.normalGridItem;

rfqMyQuotesFilterStyles.xRfqMyQuotesFilterStyles = {
    statusFilterGridItem: sharedListPagesFilterStyle.normalGridItem,
    datesGridItem: sharedListPagesFilterStyle.normalGridItem,
    datesContainer: sharedListPagesFilterStyle.customContainer,
    dateRangeFieldset: {
        css: css`
            border: none;
            margin: 0;
            padding: 0;
            width: 100%;
        `,
    },
};

rfqMyQuotesFilterStyles.salesRepGridItem = sharedListPagesFilterStyle.normalGridItem;

rfqMyQuotesFilterStyles.userGridItem = sharedListPagesFilterStyle.normalGridItem;

rfqMyQuotesFilterStyles.buttonsItem = sharedListPagesFilterStyle.buttonsItem;

rfqMyQuotesFilterStyles.clearFiltersButton = sharedListPagesFilterStyle.clearFiltersButton;
